import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Banner, BannerTypesEnum} from '../../../common/banners/banner';
import {BannerAction} from '../../../common/banners/bannerAction';
import {BannerCloseAction} from '../../../common/banners/bannerCloseAction';
import {BannerContent} from '../../../common/banners/bannerContent';
import {BannerContentTitle} from '../../../common/banners/bannerContentTitle';
import {BannerFooterActions} from '../../../common/banners/bannerFooterActions';
import {BannerIcon} from '../../../common/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../common/banners/bannersContext';

/*
 * Props.
 */

interface DomainLoginBannerProps {
  onDismissClick: Handler;
  onActionClick: Handler;
  onLearnClick: Handler;
}

/*
 * Style.
 */

const StyledDescriptionDiv = styled.div`
  padding-top: 4px;
  font-size: 12px;
`;

/*
 * Component.
 */

export const DomainLoginBanner: FC<DomainLoginBannerProps> = (props) => {
  const theme = useUserTheme();

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.blue.shade40}
      priority={BannerPrioritiesEnum.INFORMATION}
    >
      <BannerCloseAction onClick={props.onDismissClick} />
      <BannerIcon iconName="infoSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="banner-domainlogin-title">Enable Domain Login</Trans>
        </BannerContentTitle>
        <StyledDescriptionDiv>
          <Trans id="banner-domainlogin-description">
            When domain login is enabled, new signups from your email domain will be prompted to join your
            team automatically. This setting is currently disabled.
          </Trans>
        </StyledDescriptionDiv>
      </BannerContent>
      <BannerFooterActions>
        <BannerAction onClick={props.onActionClick}>
          <Trans id="banner-domainlogin-action-settings">Settings</Trans>
        </BannerAction>
        <BannerAction onClick={props.onLearnClick}>
          <Trans id="banner-domainlogin-action-learnmore">Learn More</Trans>
        </BannerAction>
      </BannerFooterActions>
    </Banner>
  );
};
